import { ExportArchiveState } from './types';

export const state = (): ExportArchiveState => initialState();

export const initialState = (): ExportArchiveState => ({
  exportArchives: {
    items: [],
    isLoading: false,
    total: 2, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdAt'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['name', 'filters', 'exportType'],
    },
  },
});
